import { ScheduleContextProvider } from "components/Dashboard/DoctorDashboard/contexts/ScheduleContext";
import type { ReactNode } from "react";

type Props = { children: NonNullable<ReactNode> };

const SetupWorkflowContextProvider = (props: Props) => (
  // create schedule
  <ScheduleContextProvider>
    {/* create welcome message */}
    {props.children}
  </ScheduleContextProvider>
);

export default SetupWorkflowContextProvider;
